import React, {useState} from "react";
import {Route, useHistory} from "react-router-dom";
import Preloader from "../components/Preloader";
import MyNavbar from "../components/MyNavbar";
// import Footer from "../components/Footer";
import {AuthConsumer} from "../context/AuthContext";
import SigninPage from "../pages/examples/SigninPage";
import GetProcess from "../components/GetProcess";
import MySidebar from "../components/MySidebar";
import FollowUpWarning from "../components/FollowUpWarning";
import PostProcess from "../components/PostProcess";

const AuthorizedRouteWithSidebar = ({ component: Component, ...rest }) => {

    const navbarRef = React.createRef();

    const [loaded, setLoaded] = useState(false);
    // const [processing, setProcessing] = useState(false);

    const processingRef = React.useRef(null);

    const postProcessingRef = React.useRef(null);

    const openPreLoader = (function openPreLoader(){
        setLoaded(false)
    })
    const closePreLoader = (function closePreLoader(){
        setTimeout(()=>setLoaded(true))
    })

    const showProcessing = (function openProcessing(){
        // setProcessing(true);
        // Global.PROCESS_LOADING = true
    })

    const closeProcessing = (function closeProcessing(){
        // Global.PROCESS_LOADING = false
        // setTimeout(() => setProcessing(false), 1000);
    })

    // let history = useHistory()

    const localStorageIsSettingsVisible = () => {
        return localStorage.getItem('settingsVisible') === 'false' ? false : true
    }

    const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
        localStorage.setItem('settingsVisible', !showSettings);
    }

    return (
        <AuthConsumer>
            {({ isAuth, user, logout }) => {
                if (!isAuth) {
                    window.location.href = SigninPage.ENDPOINT
                    return (
                        <Route {...rest} render={props => (
                            <>
                                <Preloader show={loaded ? false : true} />
                            </>
                        )}
                        />
                    )
                }
                let registration = user.registration?user.registration:{}
                return(
                    <Route
                        {...rest}
                        render={props => (
                            <>
                                <Preloader show={loaded ? false : true} />
                                <MySidebar {...props}/>
                                <main className="content p-0">
                                    <GetProcess ref={processingRef}/>
                                    <PostProcess ref={postProcessingRef}/>
                                    <MyNavbar {...props} user={user} ref={navbarRef} />
                                    <div className="p-3 mt-2">
                                        <Component
                                            {...props}
                                            openPreLoader={openPreLoader}
                                            closePreLoader={closePreLoader}
                                            showProcessing={showProcessing}
                                            closeProcessing={closeProcessing}
                                            processingRef={processingRef}
                                            postProcessingRef={postProcessingRef}
                                            navBar={navbarRef}
                                        />
                                    </div>
                                    {registration.followUp?(
                                        <>
                                            <FollowUpWarning show={true} />
                                        </>):(null)}
                                    {/*<Footer toggleSettings={toggleSettings} showSettings={showSettings} />*/}
                                </main>
                            </>
                        )}
                    />

                )
            }}
        </AuthConsumer>

    );
};
export default AuthorizedRouteWithSidebar